// =============================================
// kvKeywords — FREE in-browser keyword/tag extraction (no API cost)
// =============================================
// Default for every user. The paid Claude path (kvAi.ts) gives richer results.
// =============================================

const STOP = new Set((
  'the a an and or but of to in on for with at by from as is are was were be been being ' +
  'this that these those it its it\'s i you he she we they them his her their our your my me ' +
  'do does did done have has had having will would can could should may might must shall ' +
  'not no yes if then else when while who whom which what where why how all any both each ' +
  'few more most other some such only own same so than too very just about into over under ' +
  'again further once here there up down out off above below between through during before after ' +
  'because until than also like get got make made use used using one two three new now per via'
).split(/\s+/));

/** Top frequency keywords (single words), stopwords removed. */
export function extractKeywordsLocal(text: string, max = 10): string[] {
  const words = (text.toLowerCase().match(/[a-z][a-z0-9'+\-_.]{2,}/g) || []);
  const freq = new Map<string, number>();
  for (const w of words) {
    const k = w.replace(/[.'_-]+$/, '');
    if (k.length < 3 || STOP.has(k)) continue;
    freq.set(k, (freq.get(k) || 0) + 1);
  }
  return Array.from(freq.entries()).sort((a, b) => b[1] - a[1]).slice(0, max).map(e => e[0]);
}

/** Candidate topical tags = repeated capitalized phrases (proper nouns / concepts). */
export function extractTagsLocal(text: string, max = 6): string[] {
  const phrases = (text.match(/\b[A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+){0,2}\b/g) || [])
    .map(p => p.trim().toLowerCase())
    .filter(p => p.length > 2 && !STOP.has(p));
  const freq = new Map<string, number>();
  phrases.forEach(p => freq.set(p, (freq.get(p) || 0) + 1));
  const ranked = Array.from(freq.entries()).sort((a, b) => b[1] - a[1]).map(e => e[0]);
  // If nothing capitalized, fall back to the top single keywords.
  return (ranked.length ? ranked : extractKeywordsLocal(text, max)).slice(0, max);
}
